const url = '/countryCodes';
const Provider = 'CountryCodes';
const dbModel = 'CountryCodes';

export { url, Provider, dbModel };
